// In-page invalidation only. Credentials never enter the notification.
const listeners = new Set();
export function onChatSettingsChanged(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
export function notifyChatSettingsChanged() {
    for (const listener of [...listeners]) {
        try { listener(); } catch { /* A subscriber cannot fail a saved setting. */ }
    }
}
